export const RELATIVE_TIME_FORMAT = "MM/DD/YY h:mm a";
export const DEFAULT_LIMIT_PER_REQUEST = 50;
export const DEFAULT_PAGE_SIZE = "20";
